import "./App.css";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Price from "./pages/Price";
import Navbar from "./components/Navbar";
import PhoneNavbar from "./components/Phone-Navbar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <Navbar className={"Navbar"} />
      <PhoneNavbar className={"Phone-Navbar"} />
      <Home />
      <About />
      <Price />
      <Contact />
      <ToastContainer />
    </>
  );
}

export default App;
